<template>
  <div class="carousel_wrapper" :class="{ mobile: isMobile }">
    <a :href="getMasterPage()" class="carousel_header" :class="{ mobile: isMobile }">
      <h4>Shop the collection</h4>
      <Icon :icon="isMobile ? csgChevronSmallRight : csgChevronLargeRight" class="icon" />
    </a>
    <Carousel :list="orderedSiblingProductIds" :number-of-items="{ large: 4, medium: 4, small: 3.5 }">
      <template #item="{ data, index }">
        <a :href="getProductUrl(data)" target="_blank" rel="noopener noreferrer" :aria-label="`View product ${index + 1}`">
          <Picture :image-url="`${productUrlTemplate}${getMemberImage(data)}`" :alt="`Product ${index + 1} image`" :aspect-ratio="0.8" />
        </a>
      </template>
    </Carousel>
  </div>
</template>

<script setup>
import Carousel from '@atomic-ui/carousel/Carousel';
import Picture from '@atomic-ui/picture/Picture';
import Icon from '@atomic-ui/icon/Icon';
import { csgChevronLargeRight, csgChevronSmallRight } from '@csgSvgIcons/icons';
import { useProduct } from '~/modules/product/composables/useProduct';
import useUrlTemplate from '~/composables/useUrlTemplate.js';
import { useDeviceType } from '~/composables/utils/useDeviceType';

const { isMobile } = useDeviceType();
const { productUrlTemplate } = useUrlTemplate();
const { productData } = useProduct();
const { memberSiblingProductMap = {}, orderedSiblingProductIds = [], masterProduct = {} } = productData?.relationships || {};

const getMemberImage = (member) => {
  return memberSiblingProductMap[member]?.imagery?.images?.[0]?.filePath;
};

const getProductUrl = (member) => {
  return memberSiblingProductMap[member]?.identifier?.productUrl;
};

const getMasterPage = () => {
  return masterProduct?.identifier?.productUrl;
};
</script>

<style lang="scss" scoped>
@import '~@csgIcons/new/chevron-large-right-dark-medium';

.carousel_wrapper {
  display: flex;
  flex-direction: column;
  gap: rem-calc(16);
  overflow: hidden;
}

.carousel_header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: rem-calc(4);
  text-decoration: none;
  cursor: pointer;

  &.mobile {
    gap: 0;

    .icon {
      align-self: flex-end;
    }
  }

  &:hover {
    opacity: 50%;
  }
}
</style>

<style lang="scss" scoped brand="mcom">
.carousel_wrapper.mobile {
  overflow: unset;
}
</style>
